import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import { Allocation } from "./allocation";
import styles from "./styles.scss";

function Loader({ isLoadingTs }: Props) {
  return (
    <div className={styles.allocations}>
      <div className={classNames(styles.allocation, { [styles.even]: true })}>
        <Allocation isLoadingTs={isLoadingTs} />
      </div>
      <div className={classNames(styles.allocation, { [styles.even]: false })}>
        <Allocation isLoadingTs={isLoadingTs} />
      </div>
      <div className={classNames(styles.allocation, { [styles.even]: true })}>
        <Allocation isLoadingTs={isLoadingTs} />
      </div>
    </div>
  );
}

export { Loader };
